import { cacheTasks } from './todoCache';
import {
    fetchPendingTasksForDefaultFolder,
    fetchRecentlyCompletedTasksForDefaultFolder,
} from './fetchTasksForDefaultFolder';

export const triggerFetchForToDo = async () => {
    const responses = await Promise.all([
        fetchPendingTasksForDefaultFolder(),
        fetchRecentlyCompletedTasksForDefaultFolder(),
    ]);
    let tasks = [];
    responses.forEach(response => (tasks = tasks.concat(response?.Value)));
    cacheTasks(tasks);

    return responses;
};
